module.exports = __webpack_public_path__ + "assets/icon-cloud.anim.07c465f0.svg";